import { isString } from '../utils/is';
import { CacheConfig, createStorage } from '../utils/cache';
import { CacheEnum } from '../enum/cache';

export function getCache(config: CacheConfig) {
  const { key } = config;
  if (isString(key)) {
    const value = createStorage(config).get(key);
    // 如果获取的是 userId (CID)，转换为 number 类型
    if (key === CacheEnum.userId && value !== null && value !== undefined) {
      return Number(value);
    }
    return value;
  }
}

export function setCache(config: CacheConfig) {
  const { key, value } = config;
  if (isString(key)) {
    createStorage(config).set(key, value);
  }
}

function useCache() {
  return {
    getCache,
    setCache,
  };
}

export default useCache;
